import type { ICON_DATA, ICON_PARAMS, ICON_PARAMS_DEVICE } from './types'

import { DEFAULT_MARGIN, DEFAULT_PADDING, DEFAULT_WIDTH } from '../const'

const DEFAULT_ICON_PARAMS_DEVICE = (): ICON_PARAMS_DEVICE => ({
  hidden: false,
  width: DEFAULT_WIDTH(),
  textAlign: 'left',
  height: {
    value: 50,
    unit: 'px',
  },
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
  color: null,
  translateX: {
    value: 0,
    unit: '%',
  },
  translateY: {
    value: 0,
    unit: '%',
  },
})

export const DEFAULT_ICON_PARAMS = (): ICON_PARAMS => ({
  pc: DEFAULT_ICON_PARAMS_DEVICE(),
  tablet: DEFAULT_ICON_PARAMS_DEVICE(),
  mobile: DEFAULT_ICON_PARAMS_DEVICE(),
})

export const DEFAULT_ICON_DATA = (): ICON_DATA => ({
  id: null,
  classes: null,
  type: 'icon',
  icon: 'far fa-smile',
})